<template>
    <div class="top-breadcrumbs">
        <p @click="handleGoIndex">运营指南</p>
        <div class="breadcrumbs-icon"></div>
        <span>联合投放及官方资源</span>
    </div>
    <div class="cont top">
        <div class="title">联合投放</div>
        <p>主要包含微博，B站等社交媒体的付费推广；</p>
    </div>
    <div class="cont">
        <div class="title">官方资源申请</div>
        <p>主要包含摩点官方私域社群资源、各平台官方账号资源；</p>
    </div>
    <div class="cont">
        <div class="title">如何申请？</div>
        <p>当众筹项目进度为100%后，即可解锁以上2项特权。</p>
        <p>可在「商家中心」- 「推广服务」获取专属对接人联系方式，具体权益以实际对接权益为准。</p>
        <el-image 
            style="width: 317px;margin: 15px 0 0 0;"
            :src="resource_enter"
            :preview-src-list="imageList"
            :initial-index="0"
            :preview-teleported="true"
            fit="contain"
            loading="lazy"
        />
    </div>
</template>

<script setup>
import { useRouter } from 'vue-router'

// 统一管理CDN地址
const CDN_BASE = 'https://p6.moimg.net/mdwxapp/guide/'

const resource_enter = `${CDN_BASE}resource_enter.png`

// 图片列表，用于预览
const imageList = [resource_enter]

const router = useRouter()
const handleGoIndex = () => {
    if(sessionStorage.getItem('guide_pro_id')){
        router.push(`/project_manage/index/${sessionStorage.getItem('guide_pro_id')}`)
    } else {
        router.push((`/project_manage/index`))
    }
}

</script>

<style lang="scss" scoped>
.top-breadcrumbs{
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 400;
    padding: 0 0 40px 0;
    p{
        color: #7F7F7F;
        cursor: pointer;
    }
    .breadcrumbs-icon{
        width: 14px;
        height: 14px;
        margin: 0 10px;
        background: url('~@/assets/images/icon_right.png') no-repeat center center;
        background-size: contain;
    }
    span{
        color: #1A1A1A;
    }
}
.cont{
    margin: 60px 0 0 0;
    color: #1A1A1A;
    &.top{
        margin: 0;
    }
    .title{
        font-size: 24px;
        font-weight: 600;
        margin: 0 0 15px 0;
    }
    a{
        color: #425EB2;
    }
    p{
        font-size: 14px;
        line-height: 1.5;
    }
    .el-image {
        height: auto;
        cursor: pointer;
        
        &.enlarged {
            transform: scale(1.2);
            transform-origin: center;
            transition: transform 0.3s ease;
        }
        
        &.pc-image {
            width: 667px;
            margin:40px 0 0 40px;
        }
        
        &.app-image {
            width: 159px;
            margin:20px 0 0 0;
        }
    }
    ul{
        padding: 0 0 0 20px;
        line-height: 21px;
        li{
            font-size: 14px;
            line-height: 21px;
            strong{
                line-height: 1;
                display: block;
                padding: 20px 0 10px 0;
                font-weight: 600;
            }
            p{
                line-height: 1.5;
            }
        }
        
        &.no{
            list-style-type: decimal;
            li{
                list-style: decimal;
            }
        }
        
        &.circle{
            list-style-type: disc;
            li{
                list-style: disc;
            }
        }
    }
}
</style>